import { localStorageInstance } from '@gem/modules/storage';

const KEY_NAME = 'selected-sticker-pack';

export const set = (id: string): void => localStorageInstance.setItem(KEY_NAME, id);

export const get = (): string | null => localStorageInstance.getItem(KEY_NAME);

export const remove = (): void => localStorageInstance.removeItem(KEY_NAME);
